import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap, Layers, Smartphone, RefreshCw } from 'lucide-react';

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Zap,
      titleKey: 'features.instant.title',
      descKey: 'features.instant.description',
    },
    {
      icon: Layers,
      titleKey: 'features.variety.title',
      descKey: 'features.variety.description',
    },
    {
      icon: Smartphone,
      titleKey: 'features.mobile.title',
      descKey: 'features.mobile.description',
    },
    {
      icon: RefreshCw,
      titleKey: 'features.free.title',
      descKey: 'features.free.description',
    },
  ];

  return (
    <section id="features" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('features.title')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="feature-card p-6 rounded-2xl text-center"
            >
              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <feature.icon className="w-7 h-7 text-primary-600" />
              </div>
              
              <h3 className="font-display text-lg font-semibold text-gray-900 mb-3">
                {t(feature.titleKey)}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>

        {/* Featured Image */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="img-container">
            <img 
              src="/images/features-showcase.jpeg" 
              alt="Game Features Showcase" 
              className="w-full h-auto rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
